import type { Theme } from "@mui/material"
import { ArticleListGridTheme } from "core/themes/src/definitions/components.types"

export const createArticleListGridTheme = (theme: Theme): ArticleListGridTheme => ({
    styleOverrides: {
        root: {
            margin: "8px 8px 0 8px",
            paddingRight: "8px",
        },
    },
})
